// extracted by mini-css-extract-plugin
module.exports = {"componentsLoading":"Loading_componentsLoading__1dT0p","pastLoading":"Loading_pastLoading__nl2dF"};